export const ICON = {
  MD_SIZE: 16,
  LG_SIZE: 20,
}
